<template>
  <div>
    <kanbanBoard></kanbanBoard>
  </div>
</template>

<script>
import kanbanBoard from "@/components/KanbanBoard.vue";

export default {
  components: {
    kanbanBoard
  }
};
</script>